import Image from 'next/image'
import React from 'react'

import LearnThreadIcon from '../../assets/dottedPath.svg'
import LearnImage from '../../assets/learnImage.svg'
import SectionHeader from '../../components/SectionHeader'
import SectionLayout from '../../components/SectionLayout'

const YouWillLearnSection = () => {
  return (
    <SectionLayout className="relative max-w-7xl mx-auto">
      <div className="relative flex flex-col sm:flex-row z-10 gap-10 items-center sm:items-start justify-center">
        <div className="sm:w-5/12 sM:mt-8">
          <SectionHeader className="sm:text-left">
            You will <span className="pl-2 text-primary"> Learn</span>
          </SectionHeader>
          <p className="text-center sm:text-left text-xl mt-5">
            Throughout the course you will work on these latest technologies
            which make you job ready with decent projects portfolio
          </p>
        </div>
        <div className="z-10">
          <Image src={LearnImage.src} alt={'icon'} width={350} height={350} />
        </div>
      </div>
      <Image
        src={LearnThreadIcon.src}
        alt={'icon'}
        height={400}
        width={1400}
        className="absolute !top-[-20%] left-0 w-full z-0"
      />
    </SectionLayout>
  )
}

export default YouWillLearnSection
